import React from 'react'

import PlayButtonPath from '/assets/icons/play-btn-green.png'
import AcornsLogoPath from 'assets/icons/acorns_logo_green.svg'
import SpendPhonePath from 'assets/icons/spend-phone.png'
import { withClickTrack } from 'components/Trackers/ClickTracker'
import { TRACKER_IDS } from 'components/Trackers/trackerIDs'
import VideoModal from 'components/VideoModal'
import { TestIDs } from 'test/utils/testIds'

import Accordions from './Accordions'
import CardOverview from './CardOverview'
import { spendDetails } from './content'
import DetailsList from './DetailsList'
import { enhance } from './enhance'
import SecurityNotice from './SecurityNotice'
import {
  AcornsLogo,
  BottomGetStartedButton,
  BottomGetStartedButtonContainer,
  DesktopContentContainer,
  LayoutContainer,
  MobileContentContainer,
  SpendPhoneImage,
  SpendPhoneImageContainer,
  StyledSeparator,
  VideoPlayButton,
  VideoPlayButtonContainer,
  VideoPlayButtonTitle,
} from './styled-components'
import { Props } from './types'

const TrackedSpendWelcomeVideo = withClickTrack<any, any>(TRACKER_IDS.SPEND_INTRO.WELCOME_VIDEO)(
  VideoPlayButtonContainer,
)

const GetStartedBottomButton = withClickTrack<any, any>(TRACKER_IDS.SPEND_INTRO.GET_STARTED_BOTTOM)(
  BottomGetStartedButton,
)

export const SpendWelcome: React.SFC<Props> = ({
  getStartedOnPress,
  toggleVideo,
  videoModalOpen,
  videoSrc,
}) => (
  <>
    <LayoutContainer>
      <AcornsLogo src={AcornsLogoPath} alt="Acorns Logo" />
      <CardOverview />

      <SpendPhoneImageContainer>
        <SpendPhoneImage src={SpendPhonePath} alt="Acorns Spend" />
      </SpendPhoneImageContainer>

      <TrackedSpendWelcomeVideo
        onClick={toggleVideo}
        data-testid={TestIDs.WELCOME.SPEND.LEARN_MORE_CTA}
      >
        <VideoPlayButton src={PlayButtonPath} />
        <VideoPlayButtonTitle>Learn More</VideoPlayButtonTitle>
      </TrackedSpendWelcomeVideo>

      <VideoModal
        isOpen={videoModalOpen}
        onRequestClose={toggleVideo}
        onEnded={toggleVideo}
        videoSrc={videoSrc}
      />

      <DetailsList details={spendDetails} />

      <Accordions />

      <MobileContentContainer>
        <SecurityNotice />

        <BottomGetStartedButtonContainer>
          <GetStartedBottomButton
            onPress={getStartedOnPress}
            data-testid={TestIDs.WELCOME.SPEND.GET_STARTED_CTA_BOTTOM}
          >
            Get Started
          </GetStartedBottomButton>
        </BottomGetStartedButtonContainer>
      </MobileContentContainer>

      <DesktopContentContainer>
        <BottomGetStartedButtonContainer>
          <GetStartedBottomButton
            onPress={getStartedOnPress}
            data-testid={TestIDs.WELCOME.SPEND.GET_STARTED_CTA_BOTTOM}
          >
            Get Started
          </GetStartedBottomButton>
        </BottomGetStartedButtonContainer>

        <StyledSeparator />

        <SecurityNotice />
      </DesktopContentContainer>
    </LayoutContainer>
  </>
)

export default enhance(SpendWelcome)
